import { useId } from "react";

/**
 * The "Backlog" product mark: a rounded tile filled with the brand gradient
 * (Electric Cyan → Deep Blue) holding a stacked-list glyph — three rows of decreasing
 * width, the shorthand for a backlog. Purely decorative, so the SVG is
 * aria-hidden; the accessible product name comes from the wordmark rendered
 * beside it. Colours resolve from the design tokens, so it tracks light/dark.
 *
 * The gradient id is per-instance (useId) so several marks can share a page
 * without colliding on a duplicate SVG id.
 */
export function Logo({ className }: { className?: string }) {
  const gradientId = useId();
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          {/* Electric Cyan → Deep Blue. The cyan stop is explicit rather than a
              token: --accent is now the solid Deep-Blue highlight fill, so the
              mark keeps its own light-blue gradient endpoint. */}
          <stop offset="0%" stopColor="hsl(199 100% 45%)" />
          <stop offset="100%" stopColor="hsl(var(--primary))" />
        </linearGradient>
      </defs>
      <rect width="48" height="48" rx="12" fill={`url(#${gradientId})`} />
      <rect x="13" y="15" width="22" height="4.5" rx="2.25" fill="white" fillOpacity="0.95" />
      <rect x="13" y="21.75" width="22" height="4.5" rx="2.25" fill="white" fillOpacity="0.7" />
      <rect x="13" y="28.5" width="14" height="4.5" rx="2.25" fill="white" fillOpacity="0.45" />
    </svg>
  );
}

export default Logo;
